import React from "react";
import { Marker, Pane } from "react-leaflet";
import { windTurbineMarker } from "./WindTurbineDrawing";
import { connect } from "react-redux";

class WindTurbineDrawingMovement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Pane>
        {this.props.inWindTurbineDrawingMode &&
          this.props.currentCursorCoords &&
          this.props.displayWindTurbineCursor && (
            <Marker
              icon={windTurbineMarker}
              position={this.props.currentCursorCoords}
              zIndex={1}
              zIndexOffset={1}
            />
          )}
      </Pane>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCursorCoords: state.map.currentCursorCoords,
    inWindTurbineDrawingMode: state.map.inWindTurbineDrawingMode,
    displayWindTurbineCursor: state.map.displayWindTurbineCursor,
  };
};

export default connect(mapStateToProps, null)(WindTurbineDrawingMovement);
